q<template>
    <v-row>
        <v-dialog v-model="dialogView" width="550px">
          <v-card>
            <v-card-title class="primary white--text pr-1">Visualizar Gaiolas
              <v-spacer/>
              <div class="caption font-weight-bold">Filial: {{ idfilial }}</div>
              <v-btn @click="dialogView = false" class="mx-2 mb-1" dark icon><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider/>
            <v-card-text class="pb-0 px-0">

              <v-data-table
                  v-if="gaiolasFiliais"
                  :items="gaiolasFiliais"
                  :headers="[
                      { text: 'Código', value: 'idfilial', align:'left', class:'pl-8',  sortable: false},
                      { text: 'Data Lançamento', value: 'dtlancamento', align:'left',  sortable: false},
                      { text: 'Usuario Lançamento', value: 'usuario', align:'left', sortable: false},
                  ]"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-left pl-8"> {{ item.codigo }} </td>
                    <td class="text-left"> {{ item.dtlancamento }} </td>
                    <td class="text-left"> {{ item.usuario }} </td>
                  </tr>
                </template>
              </v-data-table>
              <v-data-table
                  v-else
                  no-data-text="Nenhuma gaiola cadastrada para esta filial"
                  :headers="[
                      { text: 'Código', value: 'idfilial', align:'left', class:'pl-8',  sortable: false},
                      { text: 'Data Lançamento', value: 'dtlancamento', align:'left',  sortable: false},
                      { text: 'Usuario Lançamento', value: 'usuario', align:'left', sortable: false},
                  ]"
              />
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogView2" width="550px">
        <v-card>
          <v-card-title class="primary white--text pr-1">Visualizar Paletes
            <v-spacer/>
            <div class="caption font-weight-bold">Filial: {{ idfilial }}</div>
            <v-btn @click="dialogView2 = false" class="mx-2 mb-1" dark icon><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pb-0 px-0">

            <v-data-table
                v-if="paletesFiliais"
                :items="paletesFiliais"
                :headers="[
                      { text: 'Quantidade', value: 'idpedido', align:'left', class:'pl-8',  sortable: false},
                      { text: 'Data Lançamento', value: 'dtlancamento', align:'left',  sortable: false},
                      { text: 'Usuario Lançamento', value: 'usuario', align:'left', sortable: false},
                  ]"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-left pl-8"> {{ item.idpedido }} </td>
                  <td class="text-left"> {{ item.dtlancamento }} </td>
                  <td class="text-left"> {{ item.usuario }} </td>
                </tr>
              </template>
            </v-data-table>
            <v-data-table
                v-else
                no-data-text="Nenhuma gaiola cadastrada para esta filial"
                :headers="[
                      { text: 'Código', value: 'idfilial', align:'left', class:'pl-8',  sortable: false},
                      { text: 'Data Lançamento', value: 'dtlancamento', align:'left',  sortable: false},
                      { text: 'Usuario Lançamento', value: 'usuario', align:'left', sortable: false},
                  ]"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
        <v-dialog v-model="dialogScanner" width="550px">
          <v-card>
            <v-card-title class="primary white--text pr-1">Adicionar Gaiolas
              <v-spacer/>
              <div class="caption font-weight-bold">Filial: {{ idfilial }}</div>
              <v-btn @click="dialogScanner = false" class="mx-2 mb-1" dark icon><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider/>
            <v-card-text>
                <v-container>
                  <!-- Lista de campos adicionais -->
                  <v-row v-for="(item, index) in itens" :key="index" @mouseenter="itens[index].status2 = true" @mouseleave="itens[index].status2 = false">
                    <v-col class="pa-0">
                      <v-autocomplete
                          :label="'Código Gaiola ' + (index+1)"
                          :items="gaiolas"
                          item-text="codigopatrimonio"
                          item-value="codigopatrimonio"
                          hide-details
                          autofocus
                          dense
                          class="mt-6"
                          outlined
                          :disabled="itens[index].status"
                          v-model="itens[index].codigo"
                          auto-select-first
                          clearable
                          @change="inserirGaiola(index)"
                      ></v-autocomplete>
                      {{ itens[index].codigo }}
                    </v-col>
                    <v-col cols="auto" class="pa-0 d-none d-md-block">
                        <v-btn
                            v-if="itens[index].status2 && itens[index].status"
                            dark
                            @click="excluirGaiola(index)"
                            class="mt-6 ml-3 error dark"
                            height="38px"
                        >
                          Excluir
                        </v-btn>
                    </v-col>
                    <v-col cols="auto" class="pa-0 d-inline-flex d-md-none">
                      <v-btn
                          v-if="itens[index].status"
                          dark
                          @click="excluirGaiola(index)"
                          class="mt-6 pa-0 ml-3 error dark"
                          icon
                      >
                        <v-icon>mdi-minus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
                <v-alert dismissible type="error" elevation="0" icon="mdi-alert" class="ma-0 mt-3" v-model="alerta.status">{{alerta.msg}}</v-alert>
            </v-card-text>
            <v-divider/>
            <v-card-actions class="px-6 py-3">
              <v-btn class="primary" width="100%" elevation="" @click="dialogScannerConfirmacao=true, dialogScanner=false" :disabled="itens.length<=1">Gravar quantidade</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogScanner2" width="550px">
          <v-card>
            <v-card-title class="primary white--text pr-1">Adicionar Paletes
              <v-spacer/>
              <div class="caption font-weight-bold">Filial: {{ idfilial }}</div>
              <v-btn @click="dialogScanner2 = false" class="mx-2 mb-1" dark icon><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider/>
            <v-card-text>
              <v-text-field
                  class="pt-4"
                  label="Quantidade Paletes"
                  autofocus
                  placeholder="Insira a quantidade de paletes"
                  outlined
                  dense
                  hide-details
                  v-model="qtdPaletes"
                  type="number"
              ></v-text-field>
              <v-alert dismissible type="error" elevation="0" icon="mdi-alert" class="ma-0 mt-3" v-model="alerta.status">{{alerta.msg}}</v-alert>
            </v-card-text>
            <v-divider/>
            <v-card-actions class="px-6 py-3">
              <v-btn class="primary" width="100%" elevation="" @click="dialogScannerConfirmacao2=true, dialogScanner2=false" :disabled="qtdPaletes.length<=0">Gravar quantidade</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogScannerConfirmacao" width="550px">
          <v-card>
            <v-card-title class="primary white--text">Confirmação de quantidade
              <v-spacer/>
              <div class="caption font-weight-bold">Filial: {{idfilial}}</div>
            </v-card-title>
            <v-card-text class="mt-6">
              <div class="text-h4 text-center font-weight-bold">Total de gaiolas conferidas </div><br/>
              <div class="text-center fonte-numero pt-3 pb-6">{{ itens.length-1 }}</div>
            </v-card-text>
            <v-divider/>
            <v-card-actions class="py-3 d-flex justify-space-between">
              <v-btn class="error flex-grow-1" elevation="" @click="dialogScannerConfirmacao=false, dialogScanner=true">Reconferir</v-btn>
              <v-btn class="primary flex-grow-1 ml-3" elevation="" @click="confirmarLancamento()">Confirmar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogScannerConfirmacao2" width="550px">
          <v-card>
            <v-card-title class="primary white--text">Confirmação de quantidade
              <v-spacer/>
              <div class="caption font-weight-bold">Filial: {{idfilial}}</div>
            </v-card-title>
            <v-card-text class="mt-6">
              <div class="text-h4 text-center font-weight-bold">Total de paletes conferidos </div><br/>
              <div class="text-center fonte-numero pt-3 pb-6">{{ qtdPaletes }}</div>
            </v-card-text>
            <v-divider/>
            <v-card-actions class="py-3 d-flex justify-space-between">
              <v-btn class="error flex-grow-1" elevation="" @click="dialogScannerConfirmacao2=false, dialogScanner2=true">Reconferir</v-btn>
              <v-btn class="primary flex-grow-1 ml-3" elevation="" @click="inserirPaletes(qtdPaletes)">Confirmar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-col cols="12" md="6">
          <v-card color="primary" dark flat>
                <v-card-title>
                  Gaiolas
                </v-card-title>
                <v-card-text>
                  <v-skeleton-loader light v-if="carregando" type="table-tbody" />
                  <v-data-table
                      v-else-if="equipamentosFiliais.length>0"
                      dense
                      light
                      :headers="[
                          { text: 'Código', value: 'idfilial', sortable: true, align:'center', class:'pr-0'},
                          { text: 'Filial', value: 'filial', sortable: true, align:'left'},
                          { text: 'Qtd. Gaiolas', value: 'qtdgaiola', sortable: true , align:'center', class:'pr-0'},
                          { text: 'Último Lançamento', value: 'dtlancamento', sortable: true, align:'center', class:'pr-0'},
                          { text: 'Ação', value: 'acao', sortable: true , align:'center', sortable: false},
                      ]"
                      :items="equipamentosFiliais"
                      item-key="name"
                      class="elevation-1"
                      hide-default-footer
                      :items-per-page="32"
                      mobile-breakpoint="0"
                  >
                    <template v-slot:item="{ item }">
                      <tr class="border-line">
                        <td class="text-center px-0" style="border: 1px solid #ccc"> {{ item.idfilial }} </td>
                        <td class="text-left"> {{ item.filial }} </td>
                        <td class="text-center px-0"> {{ item.qtdgaiola }} </td>
                        <td class="text-center px-0"> {{ item.dtlancamento | formataData}} </td>
                        <td class="text-center" width="15%" nowrap="">
                          <v-tooltip bottom color="primary" class="text-no-wrap">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn @click="idfilial = item.idfilial, listarHistoricoGaiolasEmpresa()" small color="primary" elevation="0" icon v-bind="attrs" v-on="on">
                                <v-icon>mdi-table-search</v-icon>
                              </v-btn>
                            </template>
                            <span>Vizualizar gaiolas</span>
                          </v-tooltip>
                          <v-tooltip bottom color="primary" class="text-no-wrap">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn @click="listarGaiolasLancamento(item.idfilial)" class="ml-2" small color="primary" elevation="0" icon v-bind="attrs" v-on="on">
                                <v-icon>mdi-table-plus</v-icon>
                              </v-btn>
                            </template>
                            <span>Lançar gaiolas</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
        </v-col>
        <v-col cols="6">
          <v-card color="primary" dark falt>
            <v-card-title>
              Paletes
            </v-card-title>
            <v-card-text>
              <v-skeleton-loader light v-if="carregando" type="table-tbody" />
              <v-data-table
                  v-else-if="equipamentosFiliais.length>0"
                  dense
                  light
                  :headers="[
                            { text: 'Código', value: 'idfilial', sortable: true, align:'center', class:'pr-0'},
                            { text: 'Filial', value: 'filial', sortable: true, align:'left'},
                            { text: 'Qtd. Paletes', value: 'qtdpaletes', sortable: true , align:'center', class:'pr-0'},
                            { text: 'Último Lançamento', value: 'dtlancamento', sortable: true, align:'center', class:'pr-0'},
                            { text: 'Ação', value: 'acao', sortable: true , align:'center', sortable: false},
                        ]"
                  :items="equipamentosFiliais"
                  item-key="name"
                  class="elevation-1"
                  hide-default-footer
                  :items-per-page="32"
                  mobile-breakpoint="0"
              >
                <template v-slot:item="{ item }">
                  <tr class="border-line">
                    <td class="text-center px-0" style="border: 1px solid #ccc"> {{ item.idfilial }} </td>
                    <td class="text-left"> {{ item.filial }} </td>
                    <td class="text-center px-0"> {{ item.qtdpalete }} </td>
                    <td class="text-center px-0"> {{ item.dtlancamentoPalete | formataData}} </td>
                    <td class="text-center" width="15%" nowrap="">
                      <v-tooltip bottom color="primary" class="text-no-wrap">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="idfilial = item.idfilial, listarHistoricoPaletesEmpresa()" small color="primary" elevation="0" icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-table-search</v-icon>
                          </v-btn>
                        </template>
                        <span>Vizualizar paletes</span>
                      </v-tooltip>
                      <v-tooltip bottom color="primary" class="text-no-wrap">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="dialogScanner2 = true, idfilial = item.idfilial" class="ml-2" small color="primary" elevation="0" icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-table-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Lançar paletes</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          </v-col>
    </v-row>
</template>

<script>
import { mapState } from "vuex";
import mixinFilial from "../../util/mixinFilial";
import axios from "axios";

export default {
    name: "ControleGaiola",
    mixins: [mixinFilial],
    data: () => ({
        equipamentosFiliais: {},
        gaiolasFiliais: [],
        paletesFiliais: [],
        gaiolas: [],
        alerta: { status: false , msg: ''},
        dialogScanner: false,
        dialogScanner2: false,
        dialogScannerConfirmacao: false,
        dialogScannerConfirmacao2: false,
        dialogView: false,
        dialogView2: false,
        carregando: false,
        busca: {
            dtinicio: `${new Date().getFullYear()}-${
                (new Date(
                    new Date().getFullYear(),
                    new Date().getMonth() + 1,
                    0
                ).getMonth() +
                1 <
                10
                    ? "0"
                    : "") +
                (new Date().getMonth() + 1)
            }-01`,
            dtfim: `${new Date(
                new Date().getFullYear(),
                new Date().getMonth() + 1,
                0
            ).getFullYear()}-${
                (new Date(
                    new Date().getFullYear(),
                    new Date().getMonth() + 1,
                    0
                ).getMonth() +
                1 <
                10
                    ? "0"
                    : "") +
                (new Date().getMonth() + 1)
            }-${new Date(
                new Date().getFullYear(),
                new Date().getMonth() + 1,
                0
            ).getDate()}`,
            idfilial: null,
            status: 1,
        },
        idfilial: 0,
        qtdPaletes:'',
        status: [
          { id: 1,condicao: 'Pendente', cor: 'amber darken-4'},
          { id: 2,condicao: 'Concluído', cor: 'green darken-4'},
        ],
        itens: [{codigo: '', status: false, status2: false}], // Lista para armazenar os itens adicionais
    }),
    computed: {
        ...mapState(["backendUrl", "pgLimit", "usuario"]),
        filiaisFiltro() {
            if (this.filiais.lista) {
                return this.filiais.lista.map((v) => {
                    const filial = {};
                    filial.idfilial = v.idfilial;
                    filial.filial = `${v.idfilial} - ${v.filial}`;
                    return filial;
                });
            } else {
                return [];
            }
        },
    },
    methods: {
      listarTodosEquipamentos() {
        return axios
            .post(`${this.backendUrl}equipamento/logistico/empresa/listar`, {})
            .then((res) => {
              this.equipamentosFiliais = res.data;
              this.carregando = false;
            })
            .catch(() => {
              this.carregando = false;
            });
      },
      listarGaiolasLancamento(id) {
        this.idfilial = id;
        this.listarGaiolas();
        return axios
            .post(`${this.backendUrl}equipamento/logistico/empresa/gaiola/listar`, {
              idfilial: this.idfilial
            })
            .then((res) => {
              if (res.data != null){
                this.itens = res.data.map((v) => {
                  return {
                    codigo: v.codigopatrimonio,
                    status: true,
                    status2: false,
                  };
                });
                this.itens.push({codigo: '', status: false, status2: false});
              } else {
                this.itens = [{codigo: '', status: false, status2: false}];
              }
              this.carregando = false;
              this.dialogScanner = true;
            })
            .catch(() => {
              this.carregando = false;
            });
      },
      listarGaiolas() {
        return axios
            .post(`${this.backendUrl}equipamento/logistico/gaiola/listar`, {})
            .then((res) => {
              this.gaiolas = res.data;
              this.carregando = false;
            })
            .catch(() => {
              this.carregando = false;
            });
      },
      listarHistoricoGaiolasEmpresa(){
        return axios
            .post(`${this.backendUrl}equipamento/logistico/controle/gaiola/listar`, {
              idfilial: this.idfilial
            })
            .then((res) => {
              this.gaiolasFiliais = res.data
              this.carregando = false;
              this.dialogView = true;
            })
            .catch(() => {
              this.carregando = false;
            });
      },
      listarHistoricoPaletesEmpresa(){
        return axios
            .post(`${this.backendUrl}equipamento/logistico/controle/paletes/listar`, {
              idfilial: this.idfilial
            })
            .then((res) => {
              this.paletesFiliais = res.data
              this.carregando = false;
              this.dialogView2 = true;
            })
            .catch(() => {
              this.carregando = false;
            });
      },
      excluirGaiola(index) {
        if (index >= 0 && index < this.itens.length) {
          return axios
              .post(`${this.backendUrl}equipamento/logistico/excluir`, {
                codigo: this.itens[index].codigo,
                idfilial: this.idfilial,
                palete: 0,
              })
              .then(() => {
                this.carregando = false;
                this.listarGaiolasLancamento(this.idfilial);
                this.listarTodosEquipamentos();
              })
              .catch(() => {
                this.carregando = false;
              });
        } else {
          console.error("Índice inválido!");
        }
      },
      inserirGaiola(index) {
          return axios
              .post(`${this.backendUrl}equipamento/logistico/inserir`, {
                idfilial: this.idfilial,
                codigo: this.itens[index].codigo,
                status: true,
                palete: 0,
              })
              .then(() => {
                this.itens[index].status = true
                this.itens.push({codigo: '', status: false, status2: false}); // Adiciona um novo item vazio à lista de itens
                this.listarTodosEquipamentos();
                this.carregando = false;
              })
              .catch((err) => {
                this.carregando = false;
                this.alerta.msg = err;
                this.alerta.status = true;
              });
      },
      inserirPaletes(qtd) {
        return axios
            .post(`${this.backendUrl}equipamento/logistico/inserir`, {
              idfilial: this.idfilial,
              codigo: null,
              status: false,
              palete: parseInt(qtd),
            })
            .then(() => {
              this.dialogScannerConfirmacao2 = false;
              this.listarTodosEquipamentos();
              this.carregando = false;
              this.qtdPaletes = 0;
            })
            .catch((err) => {
              this.carregando = false;
              this.alerta.msg = err;
              this.alerta.status = true;
            });
      },
      confirmarLancamento() {
        return axios
            .post(`${this.backendUrl}equipamento/logistico/inserir`, {
              idfilial: this.idfilial,
              codigo: null,
              status: false,
              palete: 0,
            })
            .then(() => {
              this.carregando = false;
              this.dialogScannerConfirmacao = false;
            })
            .catch((err) => {
              this.carregando = false;
              this.alerta.msg = err;
              this.alerta.status = true;
            });
      },
      async init() {
          this.busca.idfilial = this.usuario.idfilial;
          await this.listarTodosEquipamentos();
      },
    },
    created() {
        this.init();
    },
};
</script>

<style scoped>
.fonte-numero {
  font-family: "Arial Black", sans-serif;
  font-size: 4em;
}

.border-line td {
  border: 1px solid #ccc;
}

.border-line {
  border: 1px solid #ccc;
}

</style>